// Admin Login Service - Her şirket için ayrı admin bilgileri
// Mock API iptal olduğunda kullanılacak

export interface AdminCredentials {
  companyId: string;
  companyName: string;
  adminUsername: string;
  adminPassword: string;
  role: string;
  permissions: string[];
}

// Şirket bazında admin bilgileri
export const adminCredentials: AdminCredentials[] = [
  {
    companyId: 'company_001',
    companyName: 'ABC Teknoloji A.Ş.',
    adminUsername: 'admin_abc',
    adminPassword: 'Admin123!',
    role: 'admin',
    permissions: ['user_management', 'data_connection', 'reports', 'logs', 'settings']
  },
  {
    companyId: 'company_002', 
    companyName: 'XYZ Yazılım Ltd.',
    adminUsername: 'admin_xyz',
    adminPassword: 'XyzAdmin456!',
    role: 'admin',
    permissions: ['user_management', 'data_connection', 'reports', 'logs', 'settings']
  },
  {
    companyId: 'company_003',
    companyName: 'DEF Danışmanlık',
    adminUsername: 'admin_def',
    adminPassword: 'DefAdmin789!',
    role: 'admin', 
    permissions: ['user_management', 'data_connection', 'reports', 'logs', 'settings']
  },
  {
    companyId: 'company_004',
    companyName: 'GHI İnşaat A.Ş.',
    adminUsername: 'admin_ghi',
    adminPassword: 'GhiAdmin2024!',
    role: 'admin',
    permissions: ['user_management', 'data_connection', 'reports', 'logs', 'settings']
  },
  {
    companyId: 'company_005',
    companyName: 'JKL Eğitim Merkezi',
    adminUsername: 'admin_jkl',
    adminPassword: 'JklAdmin999!',
    role: 'admin',
    permissions: ['user_management', 'data_connection', 'reports', 'logs', 'settings']
  }
];

// Admin giriş doğrulama fonksiyonu
export const validateAdminLogin = (username: string, password: string): AdminCredentials | null => {
  const admin = adminCredentials.find(
    cred => cred.adminUsername === username && cred.adminPassword === password
  );
  
  return admin || null;
};

// Şirket ID'ye göre admin bilgilerini getir
export const getAdminByCompanyId = (companyId: string): AdminCredentials | null => {
  return adminCredentials.find(cred => cred.companyId === companyId) || null;
};

// Tüm şirket listesini getir
export const getAllCompanies = (): { companyId: string; companyName: string }[] => {
  return adminCredentials.map(cred => ({
    companyId: cred.companyId,
    companyName: cred.companyName
  }));
};

// Admin bilgilerini güncelle
export const updateAdminCredentials = (
  companyId: string, 
  newCredentials: Partial<AdminCredentials>
): boolean => {
  const index = adminCredentials.findIndex(cred => cred.companyId === companyId);
  if (index !== -1) {
    adminCredentials[index] = { ...adminCredentials[index], ...newCredentials };
    return true;
  }
  return false;
};

// Yeni şirket admin'i ekle
export const addNewCompanyAdmin = (newAdmin: AdminCredentials): boolean => {
  const exists = adminCredentials.find(cred => cred.companyId === newAdmin.companyId);
  if (!exists) {
    adminCredentials.push(newAdmin);
    return true;
  }
  return false;
};

// Şirket admin'ini sil
export const removeCompanyAdmin = (companyId: string): boolean => {
  const index = adminCredentials.findIndex(cred => cred.companyId === companyId);
  if (index !== -1) {
    adminCredentials.splice(index, 1);
    return true;
  }
  return false;
};

// Admin giriş logları (basit)
export const adminLoginLogs: Array<{
  companyId: string;
  username: string;
  loginTime: Date;
  ipAddress: string;
  success: boolean;
}> = [];

// Giriş logu ekle
export const logAdminLogin = (
  companyId: string,
  username: string,
  ipAddress: string = '127.0.0.1',
  success: boolean = true
): void => {
  adminLoginLogs.push({
    companyId,
    username,
    loginTime: new Date(),
    ipAddress,
    success
  });
};

// Giriş loglarını getir
export const getAdminLoginLogs = (companyId?: string) => {
  if (companyId) {
    return adminLoginLogs.filter(log => log.companyId === companyId);
  }
  return adminLoginLogs;
};

// Güvenlik: Şifre değiştirme
export const changeAdminPassword = (
  companyId: string,
  currentPassword: string,
  newPassword: string
): boolean => {
  const admin = adminCredentials.find(cred => cred.companyId === companyId);
  if (admin && admin.adminPassword === currentPassword) {
    admin.adminPassword = newPassword;
    return true;
  }
  return false;
};

// Güvenlik: Şifre güçlülük kontrolü
export const validatePasswordStrength = (password: string): {
  isValid: boolean;
  errors: string[];
} => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('Şifre en az 8 karakter olmalıdır');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Şifre en az bir büyük harf içermelidir');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Şifre en az bir küçük harf içermelidir');
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push('Şifre en az bir rakam içermelidir');
  }
  
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Şifre en az bir özel karakter içermelidir');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

const adminLoginService = {
  validateAdminLogin,
  getAdminByCompanyId,
  getAllCompanies,
  updateAdminCredentials,
  addNewCompanyAdmin,
  removeCompanyAdmin,
  logAdminLogin,
  getAdminLoginLogs,
  changeAdminPassword,
  validatePasswordStrength
};

export default adminLoginService;
